import type { TabType } from '@heidi/session/contracts';
import { createContext, useContext } from 'react';

export interface ArtifactCanvasNavigationValue {
  readonly enabled: true;
  readonly sessionId: string;
  readonly openDocument: (documentId: string) => void;
  readonly openNote: () => void;
  readonly openTasks: () => void;
  readonly openCodes: () => void;
  /**
   * Intercept a Scribe tab switch. Returns true when the tab was handled
   * as an artifact drill-down (caller should skip in-session tab mutation).
   * Session tabs return false so the strip switches in-place.
   */
  readonly handleTabChange: (name: TabType, documentId?: string) => boolean;
}

export const ArtifactCanvasNavigationContext =
  createContext<ArtifactCanvasNavigationValue | null>(null);

export const useArtifactCanvasNavigationOptional =
  (): ArtifactCanvasNavigationValue | null => useContext(ArtifactCanvasNavigationContext);
